module.exports = __webpack_public_path__ + "img/kehu_6@2x.28e6caca.png";